<script>

	export default {

	  inserted: (el) => {
		    /*
			  //use on parent and not on individual elem
				<div v-lazy-load>
					<div class="lazy-load">Something</div>
					<div class="lazy-load">Something</div>
					<div class="lazy-load">Something</div>
				<div>
			*/

	  		function debounce(func, wait = 20, immediate = true) {
	  			var timeout;
	  			return function() {
	  				var context = this, args = arguments;
	  				var later = function() {
	  					timeout = null;
	  					if(!immediate) func.apply(context, args);
	  				}
	  				var callNow = immediate && !timeout;
	  				clearTimeout(timeout);
	  				timeout = setTimeout(later, wait);
	  				if(callNow) func.apply(context, args);
	  			};
	  		};

	  		const fadeElem = document.querySelectorAll('.lazy-load');

	  		function lazyLoad(e) {
	  			for(let i = 0; i < fadeElem.length; i++) {
	  				const elem = fadeElem[i];
	  				
	  				const fadeInAt = (window.pageYOffset + window.innerHeight) - $(elem).height() / 10;
	  				const elemBottom = elem.offsetTop + $(elem).height();
	  				const isHalfShown = fadeInAt > elem.offsetTop;
	  				const isNotScrolledPast = window.pageYOffset < elemBottom;
	  				if(isHalfShown && isNotScrolledPast) {
	  					elem.classList.add('fade-in')
	  				}
	  			}
	  		}
	  		lazyLoad();
	  		window.addEventListener('scroll', debounce(lazyLoad));

	  }

	}

</script>